var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWebFooterInstaIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0396 36.6004H17.9604C8.05714 36.6004 0 28.5409 0 18.6348V18.5555C0 8.64934 8.05714 0.589844 17.9604 0.589844H18.0396C27.9429 0.589844 36 8.64934 36 18.5555V18.6348C36 28.5409 27.9429 36.6004 18.0396 36.6004ZM17.9604 1.80877C8.72857 1.80877 1.21856 9.32097 1.21856 18.5555V18.6348C1.21856 27.8693 8.72857 35.3815 17.9604 35.3815H18.0396C27.2714 35.3815 34.7814 27.8693 34.7814 18.6348V18.5555C34.7814 9.32097 27.2714 1.80877 18.0396 1.80877H17.9604Z",
    fill: "#059669"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.385 8.2793H12.6226C9.64932 8.2793 7.23047 10.6989 7.23047 13.673V23.5219C7.23047 26.4961 9.64932 28.9156 12.6226 28.9156H23.385C26.3583 28.9156 28.7771 26.4961 28.7771 23.5219V13.673C28.7771 10.6989 26.3583 8.2793 23.385 8.2793ZM9.13265 13.673C9.13265 11.7483 10.6985 10.182 12.6226 10.182H23.385C25.3091 10.182 26.8749 11.7483 26.8749 13.673V23.5219C26.8749 25.4466 25.3091 27.0129 23.385 27.0129H12.6226C10.6985 27.0129 9.13265 25.4466 9.13265 23.5219V13.673Z",
    fill: "#059669"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0039 23.6142C20.7688 23.6142 23.0195 21.3641 23.0195 18.5971C23.0195 15.8302 20.77 13.5801 18.0039 13.5801C15.2378 13.5801 12.9883 15.8302 12.9883 18.5971C12.9883 21.3641 15.2378 23.6142 18.0039 23.6142ZM18.0039 15.484C19.7208 15.484 21.1173 16.8809 21.1173 18.5984C21.1173 20.3158 19.7208 21.7127 18.0039 21.7127C16.2869 21.7127 14.8905 20.3158 14.8905 18.5984C14.8905 16.8809 16.2869 15.484 18.0039 15.484Z",
    fill: "#059669"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4842 14.3891C24.2287 14.3891 24.8356 13.7833 24.8356 13.0373C24.8356 12.2914 24.23 11.6855 23.4842 11.6855C22.7384 11.6855 22.1328 12.2914 22.1328 13.0373C22.1328 13.7833 22.7384 14.3891 23.4842 14.3891Z",
    fill: "#059669"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebFooterInstaIcon);
export default __webpack_public_path__ + "static/media/web_footer_Insta_icon.c408ac7d8c65a40168e874a199a15deb.svg";
export { ForwardRef as ReactComponent };